// TopUPApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'TopUP'];

// Enhance the base API service by adding entication-related tag types
const TopUPApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      // Create a new 
        createTopUp: build.mutation({
            query: ({ topUp,payment_id, user_id }) => ({
              url: `/topups/${payment_id}/${user_id}`,
              method: 'POST',
              data: topUp,  // Using ShopProfile interface data here
            }),
            invalidatesTags: ['TopUP'],  // Invalidate ShopProfiles tags after creation
          }),
      // Fetch TopUP query (GET request to /me)
      getTopUP: build.query({
        query: (userId) => ({
          url: `/topups/user/${userId}/with_payment_name`,
        }),
        providesTags: ['TopUP'],
      }), 
      
      // Delete   mutation (DELETE request  )
      deleteResquedAmount: build.mutation({
        query: (id) => ({
          url: `/topups/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['TopUP'], // Invalidate the user tag after deletion
      }),  
    }),
    overrideExisting: false,
  });

export default TopUPApi;

// Exporting hooks for each endpoint to be used in components
export const {
    useCreateTopUpMutation,
   useGetTopUPQuery,
   useDeleteResquedAmountMutation
    
} = TopUPApi;


